module.exports = __webpack_public_path__ + "media/beautiful_in_white.9fec2739.mp3";